import { SIERRA_AI } from './constants';

export const getChatType = () => SIERRA_AI;

export const openCSChat = () => window.sierra.openChatModal();

export const handleClickChatWithUs = () => {
  openCSChat();
};
